export { default }from './PaymentInfo';
